import React, { useEffect, useState } from 'react';
import { AppProvider } from './contexts/AppContext';
import { WelcomeScreen } from './components/screens/WelcomeScreen';
import { TutorialScreen } from './components/screens/TutorialScreen';
import { GameScreen } from './components/screens/GameScreen';
import { PostMatchScreen } from './components/screens/PostMatchScreen';
import { LeaderboardScreen } from './components/screens/LeaderboardScreen';
import { FriendsScreen } from './components/screens/FriendsScreen';
import { ShopScreen } from './components/screens/ShopScreen';
import { ProfileScreen } from './components/screens/ProfileScreen';
import { BottomNav } from './components/layout/BottomNav';
import { GameSettings } from './components/settings/SettingsScreen';
type Screen = 'welcome' | 'tutorial' | 'game' | 'post-match' | 'leaderboard' | 'friends' | 'shop' | 'profile';
interface MatchStats {
  moves: number;
  duration: number;
  connectedChips: number;
  averageMoveTime: number;
}
function AppContent() {
  const [currentScreen, setCurrentScreen] = useState<Screen>('welcome');
  const [matchWinner, setMatchWinner] = useState<number | null>(null);
  const [matchStats, setMatchStats] = useState<MatchStats>({
    moves: 0,
    duration: 0,
    connectedChips: 0,
    averageMoveTime: 0
  });
  const [activeTab, setActiveTab] = useState('home');
  const [settings, setSettings] = useState<GameSettings & {
    hideProduct?: boolean;
  }>({
    timePerRound: 45,
    soundEffects: true,
    music: false,
    hideProduct: false,
    zoomLevel: 100
  });
  // Apply zoom level to root element
  useEffect(() => {
    document.documentElement.style.fontSize = `${settings.zoomLevel}%`;
  }, [settings.zoomLevel]);
  const handleGameFinish = (winner: number | null, stats: MatchStats) => {
    setMatchWinner(winner);
    setMatchStats(stats);
    setCurrentScreen('post-match');
  };
  const handleTutorialComplete = () => {
    setCurrentScreen('game');
  };
  const handlePlayGame = (hideProduct: boolean) => {
    setSettings(prev => ({
      ...prev,
      hideProduct
    }));
    setCurrentScreen('game');
  };
  const handleFriendGame = (roomCode: string, gameSettings: GameSettings & {
    hideProduct: boolean;
  }) => {
    setSettings(gameSettings);
    setCurrentScreen('game');
    console.log('Starting friend game with code:', roomCode);
  };
  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    const screenMap: Record<string, Screen> = {
      home: 'welcome',
      ranks: 'leaderboard',
      friends: 'friends',
      shop: 'shop',
      profile: 'profile'
    };
    setCurrentScreen(screenMap[tab] || 'welcome');
  };
  const showBottomNav = ['welcome', 'leaderboard', 'friends', 'shop', 'profile'].includes(currentScreen);
  return <div className="w-full h-full min-h-screen bg-slate-50 font-sans text-slate-900 overflow-hidden max-w-md mx-auto relative shadow-2xl" data-id="element-0">
      {currentScreen === 'welcome' && <WelcomeScreen onPlay={handlePlayGame} onTutorial={() => setCurrentScreen('tutorial')} onFriendGame={handleFriendGame} data-id="element-1" />}

      {currentScreen === 'tutorial' && <TutorialScreen onComplete={handleTutorialComplete} onSkip={() => setCurrentScreen('game')} data-id="element-2" />}

      {currentScreen === 'game' && <GameScreen onBack={() => setCurrentScreen('welcome')} onFinish={handleGameFinish} settings={settings} onSettingsChange={setSettings} data-id="element-3" />}

      {currentScreen === 'post-match' && <PostMatchScreen winner={matchWinner} matchStats={matchStats} onRematch={() => setCurrentScreen('game')} onHome={() => setCurrentScreen('welcome')} data-id="element-4" />}

      {currentScreen === 'leaderboard' && <LeaderboardScreen currentUser={{
      name: 'You',
      rank: 12
    }} data-id="element-5" />}

      {currentScreen === 'friends' && <FriendsScreen data-id="element-6" />}

      {currentScreen === 'shop' && <ShopScreen data-id="element-7" />}

      {currentScreen === 'profile' && <ProfileScreen settings={settings} onSettingsChange={setSettings} data-id="element-8" />}

      {/* Bottom Navigation */}
      {showBottomNav && <BottomNav activeTab={activeTab} onTabChange={handleTabChange} data-id="element-9" />}
    </div>;
}
export function App() {
  return <AppProvider data-id="element-10">
      <AppContent data-id="element-11" />
    </AppProvider>;
}